import { useMutation, useQuery, type UseMutationResult, type UseQueryResult } from '@/lib/query';
import { getAllUsersForImpersonation, impersonateUser } from '@/lib/api/impersonation';
import { ImpersonationUserDto } from '@cargovibe/shared-types';

const ALL_USERS_QUERY_KEY: string[] = ['all-users-for-impersonation'];

/**
 * Calls the backend to mint a Clerk impersonation ticket for the given
 * externalAuthId (Clerk's own user id) and returns the raw ticket. The caller
 * decides where to redeem it (see `ImpersonateUserPanel`'s destination
 * picker) — whichever app redeems it is where the impersonated session lands.
 */
export function useImpersonateUser(): UseMutationResult<string, Error, string> {
  return useMutation<string, Error, string>({
    mutationFn: async (externalAuthId: string): Promise<string> => {
      const { token } = await impersonateUser(externalAuthId);
      return token;
    },
  });
}

/** Every user in the system, unscoped by company — feeds the picker table on the Impersonate page. */
export function useAllUsersForImpersonation(): UseQueryResult<ImpersonationUserDto[]> {
  return useQuery<ImpersonationUserDto[]>({
    queryKey: ALL_USERS_QUERY_KEY,
    queryFn: getAllUsersForImpersonation,
  });
}
